import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-black border-y border-dark-border" data-id="element-126" data-mp="1o2vk0ww891a9">
      <div className="max-w-4xl mx-auto" data-id="element-127" data-mp="223ofpky9m2ey">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-dark-card border border-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-128" data-mp="222mz70yhcnpu">
          <div className="absolute top-0 left-0 w-full h-1 bg-gold-gradient" data-id="element-129" data-mp="1j5luzicr2rmy" />

          <span className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold/10 text-gold mb-8" data-id="element-130" data-mp="1edby1id7wrb6">
            <ShieldCheckIcon size={48} aria-hidden="true" data-id="element-131" data-mp="qn7utc3xytkp" />
          </span>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-132" data-mp="lpogydb5oita">
            🛡️ Garanzia totale di 7 giorni
          </h2>

          <div className="space-y-6 text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-133" data-mp="oyqewbuo01kq">
            <p data-id="element-134" data-mp="txt6oulmwbar">
              Apri i 6 volumi. Esplora i 5 bonus. Utilizza il materiale nella
              tua lezione più impegnativa.
            </p>
            <p className="font-medium text-white" data-id="element-135" data-mp="yrfkiq3jal85">
              Se ritieni che il materiale non sia adatto alle tue esigenze:
            </p>
            <p className="text-gold-light font-bold text-xl" data-id="element-136" data-mp="61ffmr91985a">
              Ti rimborsiamo il 100% del tuo acquisto.
            </p>
            <p data-id="element-137" data-mp="b0a5gd5f3wyw">
              Secondo i termini della garanzia, puoi richiedere il rimborso
              entro 7 giorni.
            </p>
            <p className="text-sm text-gray-400" data-id="element-138" data-mp="k0f4o00gjp1z">
              Perché se il materiale non ti offre il valore che cerchi, non
              vogliamo che tu sia costretto a tenerlo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}